<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">合同备案</div>

      <!-- 查询区域 -->
      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="项目名称">
            <a-input placeholder="请输入项目名称" style="width: 250px" />
          </a-form-item>
          <a-button type="primary">提交</a-button>
          <a-button style="margin-left: 10px;">清空</a-button>
        </a-form>
      </div>

      <!-- 表格 -->
      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1300 }"
        locale="{ emptyText: '暂无数据' }"
      >
        <template slot="operation">
          <a style="color: #1890ff;">查看</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: '备案编号', dataIndex: 'recordCode', width: 180, key: 'recordCode' },
        { title: '项目名称', dataIndex: 'projectName', width: 250, key: 'projectName' },
        { title: '出租方', dataIndex: 'lessor', width: 180, key: 'lessor' },
        { title: '权证编号', dataIndex: 'certificateCode', width: 200, key: 'certificateCode' },
        { title: '合同总租金(元)', dataIndex: 'totalRent', width: 180, key: 'totalRent' },
        { title: '备案类型', dataIndex: 'recordType', width: 120, key: 'recordType' },
        { title: '备案日期', dataIndex: 'recordDate', width: 160, key: 'recordDate' },
        { title: '操作', key: 'operation', fixed: 'right', width: 100, scopedSlots: { customRender: 'operation' } },
      ],
      data: [] // 暂无数据
    };
  }
};

</script>
<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
</style>